import { render, staticRenderFns } from "./trainingCenter.vue?vue&type=template&id=56fdec29&scoped=true&"
import script from "./trainingCenter.vue?vue&type=script&lang=js&"
export * from "./trainingCenter.vue?vue&type=script&lang=js&"
import style0 from "./trainingCenter.vue?vue&type=style&index=0&id=56fdec29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdec29",
  null
  
)

export default component.exports